module.exports = __webpack_public_path__ + "static/media/wp_6.cda59886.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/wp_6.png
// module id = 35
// module chunks = 0